import { message } from "antd";
import axios from "axios";
import md5 from "md5";
import { FILE_UPLOADS } from "../../Graphql/mutations";
import { client } from "../../Utils/Apollo/apolloClient";

export const onFileUpload = async (
  { file, onSuccess, onError, onProgress },
  uploadFolderName,
  returnUploadedFiles,
  setIsUploading
) => {
  
  const { signedUrl, fileName } = await generateUploadedUrl(
    file,
    uploadFolderName
  );
  const CancellationToken = axios.CancelToken.source();
  axios
    .put(signedUrl, file, {
      onUploadProgress: ({ total, loaded }) => {
        if (onProgress) {
          onProgress({
            percent: Math.round((loaded / total) * 100).toFixed(2),
            file,
          });
        }
        if (loaded === total && !!setIsUploading) {
          setIsUploading(false);
        }
      },
      cancelToken: CancellationToken.token,
      headers: {
        "Content-Type": file.type,
      },
    })
    .then(({ data: response }) => {
      returnUploadedFiles(fileName);
    })
    .catch((error) => {
      if (error.message === "Network Error") {
        message.error(
          "File upload failed due to unstable internet connection."
        );
        onError(error);
        setIsUploading(false);
      }
    });
};

const generateUploadedUrl = async ({ name, type }, uploadFolderName) => {
  try {
    var fileName =
      uploadFolderName +
      "/" +
      md5(name) +
      new Date().toLocaleDateString().replace("/", "").replace("/", "") +
      new Date().getTime() +
      "." +
      name.split(".")[name.split(".").length - 1];

    const {
      data: { generateUrl },
    } = await client.mutate({
      mutation: FILE_UPLOADS,
      variables: {
        fileName,
        fileType: type,
      },
    });
    return { signedUrl: generateUrl, fileName: fileName };
  } catch (error) {
    throw error;
  }
};
